import {
  KTNDetails,
  KTNDetailsStatusEnum,
} from '@clear-denver/tpc-openapi-typescript/build/v1/enrollment'
import type { ApplicantStatusDetails } from '@clear-denver/tpc-openapi-typescript/build/v1/enrollment'

export function resolveKtnSuccessCode(data: KTNDetails): string {
  const isClear = data.provider === 'CLEAR'

  if (!isClear) {
    return data.status === KTNDetailsStatusEnum.ELIGIBLEFORRENEWAL
      ? 'OTHER_ELIGIBLE_RENEWAL'
      : 'OTHER_PROVIDER'
  }

  switch (data.status) {
    case KTNDetailsStatusEnum.COMPLETED:
      return 'CLEAR_KTN_ISSUED'
    case KTNDetailsStatusEnum.ELIGIBLEFORRENEWAL:
      return 'CLEAR_ELIGIBLE_RENEWAL'
    case KTNDetailsStatusEnum.NOTELIGIBLEFORRENEWAL:
      return 'CLEAR_NOT_ELIGIBLE_RENEWAL'
    case KTNDetailsStatusEnum.INPROGRESS:
      return data.ktn
        ? 'CLEAR_RENEWAL_IN_PROGRESS'
        : 'CLEAR_ENROLLMENT_IN_PROGRESS'
    default:
      return 'UNKNOWN'
  }
}

export function resolveStatusSuccessCode(data: ApplicantStatusDetails): string {
  if (!data.determinationStatus) return 'UNKNOWN'
  return 'STATUS_' + data.determinationStatus.toUpperCase().replace(/\s+/g, '_')
}
